// extracted by mini-css-extract-plugin
export default {"wrapper_app":"HomePage_wrapper_app__7sKlB"};